import App from 'App/App';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import AppLoader from './components/Loading/AppLoader';
import './index.css';
import localizationService from './services/Localization/i18n';
import { removeUnknownLocalStorageData } from './utils/localstorage';

//
// Initialization
//
localizationService.init();
removeUnknownLocalStorageData();

//
// Main render
//
const rootElement = document.getElementById('root');
if (rootElement) {
  //no StrictMode: its double mount would start the silent sign-in twice (AppContextProvider.componentDidMount)
  createRoot(rootElement).render(
    <Suspense fallback={<AppLoader />}>
      <App />
    </Suspense>,
  );
}
